<template>

</template>

<script>
    export default {
        props: ['map','athlete'],
        name: "test",
        data () {
          return {
            marker: null
          }
        },
        watch: {
          map: function() {
            if(typeof this.map !== 'undefined'){
              this.marker.setMap(this.map)
              console.log(this.marker)
            }
          },
          athlete: function (oldAthlete, newAthlete) {
            if(oldAthlete.properties.latitude !== newAthlete.properties.latitude || oldAthlete.properties.longitude !== newAthlete.properties.longitude) {
              this.setPostion();
            }
          }
        },
        created() {
          this.marker = new google.maps.Marker({
            position: {lat: this.athlete.properties.latitude, lng: this.athlete.properties.longitude},
            map: this.map,
            optimized: false
          })
        },
        methods: {
          setPostion : function() {
            if(this.marker !== null && this.map !== null && this.athlete.properties.latitude !== null) {
              let myLatlng = new google.maps.LatLng(parseFloat(this.athlete.properties.latitude), parseFloat(this.athlete.properties.longitude))
              this.marker.setPosition(myLatlng)
            }
          }
        },
        beforeDestroy() {
          this.marker.setMap(null);
          this.marker = null;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/map/test.vue